import {collection, doc, getDoc, setDoc, getFirestore, serverTimestamp, updateDoc, where, query, getAggregateFromServer, sum, initializeFirestore} from 'firebase/firestore'
import { app } from './init'
import { User, type Profile, TalkResult } from './validator'

initializeFirestore(app, {ignoreUndefinedProperties: true})
const db = getFirestore(app)

const users = collection(db, 'users').withConverter({
  toFirestore (user: User) {
    // Validate user data before saving
    const validatedUser = User.parse(user)
    return {
      ...validatedUser,
      profile: JSON.stringify(validatedUser.profile)
    }
  },
  fromFirestore (ss) {
    const data = ss.data()
    const profile = data.profile ?
      JSON.parse(data.profile) as Profile
      :
      {profile: '', job: '', tastes: '', now: ''}
    return User.parse({
      ...data,
      ready: data.ready?.toDate(),
      created_at: data.created_at.toDate(),
      last_visit_at: (data.last_visit_at || data.created_at).toDate(), // last_visit_atがない場合用
      profile,
    })
  }
})

export const getUser = (uid: string) =>
  getDoc(doc(users, uid))
    .then(ss=> {
      const data = ss.data()
      return data
    })

export type UpdateUser = Partial<Pick<User, 'name' | 'icon' | 'profile' | 'email' | 'notification'>>

export const initUser = (uid: string, data: UpdateUser) => {
  const user_data = {
    name: '',
    icon: '',
    role: 'user' as const,
    profile: {profile: '', job: '', tastes: '', now: ''},
    created_at: serverTimestamp(),
    email: '',
    notification: false,
    terms_agree_version: 0,
    point: 0, // 同一メールアドレス登録等弾きたいので初期値は0
    last_visit_at: serverTimestamp(),
    ...data,
  }
  return setDoc(doc(users, uid), user_data)
    .then(()=> ({...user_data, created_at: new Date(), last_visit_at: new Date()}))
}

export const updateUser = (uid: string, data: UpdateUser) =>
  updateDoc(
    doc(users, uid),
    {...data, profile: data.profile && JSON.stringify(data.profile)}
  )

const talk_results = collection(db, 'talk_results').withConverter({
  toFirestore (talk: TalkResult) {
    return talk
  },
  fromFirestore (ss) {
    const data = ss.data()
    return TalkResult.parse({
      ...data,
      start_at: data.start_at.toDate(),
      end_at: data.end_at.toDate()
    })
  }
})

export const countPositiveTalkResults = (cast_id: string) =>
  getAggregateFromServer(
    query(talk_results, where('cast_id', '==', cast_id)),
    {positive_sum: sum('positive')}
  )
    .then(ss=> ss.data().positive_sum)

export const evaluteTalkResult = (doc_id: string, positive: number) =>
  updateDoc(doc(talk_results, doc_id), {positive})

export const termsAgree = (uid: string) =>
  updateDoc(doc(users, uid), {terms_agree_version: 1})